"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var _types_1 = require("../../types");
exports.default = (_a = {},
    _a[_types_1.Network.goerli] = {
        POOL_FACTORY: '0xE4452a09eDDc633f9f51D8c0a01BFDa18f35441d',
    },
    _a[_types_1.Network.mainnet] = {
        POOL_FACTORY: '0x89E583A67B5FA1B39b8CE7E77654071c3a34cc48',
    },
    _a[_types_1.Network.optimismGoerli] = {
        POOL_FACTORY: '0x6696d9dFE0a28e5bc9d47C32DDEa0295Fdfb8B27',
    },
    _a[_types_1.Network.optimism] = {
        POOL_FACTORY: '0x4f2bE0244146B4408154504A481C799ba1A9A355',
    },
    _a[_types_1.Network.scrollAlphaTestnet] = {
        POOL_FACTORY: '0xf83A823a57B2C67A71a91BFDe2Ef6CA4c0F5c031',
    },
    _a[_types_1.Network.arbitrumGoerli] = {
        POOL_FACTORY: '0xA638037F0FE36199C884b6784ABEf77Da49D614e',
    },
    _a[_types_1.Network.zksyncGoerli] = {
        POOL_FACTORY: '0x148ADe234670974720752C630f0003c168f68ff0',
    },
    _a[_types_1.Network.zksyncEra] = {
        POOL_FACTORY: '0xCE38604C2cF369e9cc67DF75E2Bd5626184D56A0',
    },
    _a[_types_1.Network.arbitrumOne] = {
        POOL_FACTORY: '0x1A53b3500216D547186C833c35F39a82053B7223',
    },
    _a);
